export default "__VITE_ASSET__CwSlNWJS__"